import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Kion mi faru nun?
    </p>

    <p class="mb-3">
      Kio okazos al mi, sola sur la fremda planedo, senkonscia, senhelpa?
    </p>

    <p class="mb-3">
      Mi timas, mi tordiĝas pro senespero, el mi estas elprenita la akso. 
      Mi nenion kapablas plu.
    </p>

    <p class="mb-3">
      Ili forflugis antaŭ 3 tagoj.
    </p>

    <p class="mb-3">
      La plej terura tamen estas ne mia soleco, sed mia senpovo. 
      Mi ne plu havas menson. 
      En la cerbo – kaĉo el nekompreneblaj vortoj, nocioj… 
      Mi forgesis la signifon de la vortoj, kaj ili restis por mi nur simplaj songluaĵoj, nenion klarigantaj, malplenaj.
    </p>

    <p class="mb-5">
      Mi perdis min.
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>
    

    <p class="mb-3">
      Tio komenciĝis dum eliro el la Ŝipo. Kiel ĉiam, mi severe obeis la Riton: dirinte la necesan magian parolon, mi prokis la krumbojn, verenis falbukojn kaj ĉeputis pertenojn.. 
      Post tio ni rajtis foriri el la Ŝipo.
    </p>

    <p class="mb-3">
      Mi estis la unua; kiam mi ektuŝis la grundon, ĝi kvazaŭ ekbalanciĝis, kaj mia kapo ekturniĝis.
    </p>

    <p class="mb-3">
      Nu kian do diablon, mi ne estas ja delikata knabino por sveni..
    </p>

    <p class="mb-3">
      Kiam mi ekfalis, la Kapitano haltigis la Eliron.
    </p>

    <p class="mb-3">
      Mi provis alrampi al la Ŝipo, sed ekvidis la firme fermitan lukon. 
      Multe da tempo postulis de mi kompreni, ke oni ne lasos min reen.
    </p>

    <p class="mb-3">
      Poste mi ekkomprenis: la Rito.
    </p>

    <p class="mb-3">
      Mi rompis la Riton, kaj por ĉiam forstrekis min el la normala homaro. 
    </p>
    
    <p class="mb-3">
      Sen Rito ne eblas la vivo; ĝi estas nia karno kaj spirito, la aero, per kiu ni spiras.
    </p>

    <p class="mb-3">
      La pastroj de l’ Rito renkontas nin dum naskiĝo; ili instruas en lernejoj; la plej kapablaj el ni studas la plenan Ritaron en universitatoj kaj mem iĝas pastroj. 
      Mi estas simpla kalpumisto, sed sen rito mi povus iĝi nenio, - sen ĝi ne eblas ja ia ajn laboro aŭ agado. 
      Kaj jen – mi rompis la Riton kaj perdis ĝin en mi mem.
    </p>

    <p class="mb-3">
      Mi forgesis ĝin.
    </p>

    <p class="mb-5">
      Mi iĝis nenio.
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>
    

    <p class="mb-3">
      Jam pasis du monatoj post mia alveno.
    </p>

    <p class="mb-3">
      Mi ĝis nun ne mortis.
    </p>

    <p class="mb-5">
      Mi nutras min per aĵoj, čirkaŭantaj min. Mi ne scias iliajn nomojn. Unuj estas dolĉaj, aliaj – preskaŭ sengustaj, sed nutrivaj. 
      Mi nomis ilin «beroj» kaj «legomoj», kvankam ili estas pli profunde diversspecaj. 
      Mi vidas, ke eble mi estos devigita nomi ĉiun specon per sia propra nomo… 
      Estas kvazaŭ ekscio de la mondo, de la nova mondo por mi. 
      Kaj nur tio savas min en mia stranga, soleca kaj ofte netolerebla vivo…
    </p>
    

    <p class="text-center bold mb-3 mt-3">* * *</p>


    <p class="mb-3 italic">
      Jen estas unuaj tekstoj de la Sankta Mesaĝo nia, de l’ Evangelio pri benata Savinto kaj Kleriganto, kiu donis nomojn al ĉiu besto kaj planto, kiu instruis al ni la Lingvon, agrikulturon kaj bestobredadon, kiu donacis al ni nian Mondon kun ĉio ekzistanta.
    </p>
    <p class="mb-3 italic">
      Laŭdu nian Kreinton! Laŭdu Lin ĥore kaj po unu, kaj en ĉiu koro flamu la sama amo kaj obeo al la granda Donanto.
    </p>
    <p class="mb-5 italic">
      Kaj memoru ni Liajn vortojn, forgesu ilin neniam, por ke ĉio dirita de Li restu por ĉiam neŝanĝebla kaj firma!
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>


    <p class="mb-3">
      Mi komprenis nun, kio okazis al mi; kio okazis al ni ĉiuj.
    </p>

    <p class="mb-3">
      Iam en paratempo, kiam ni estis same sovaĝaj, kiel tiuj triboj, ĉirkaŭantaj min, okazis Intruzo al la Tero, kaj la alvenintoj penis «feliĉigi» nin per nova scio, «civilizigi» nin.
    </p>

    <p class="mb-3">
      Ili semis inter ni valoran scion, kaj ni prenis ĝin, ĝoje, sen pripenso.
    </p>

    <p class="mb-3">
      Sen pripenso.
    </p>

    <p class="mb-3">
      Ni restis sur la sama nivelo, kaj ni ne plu esploris la ĉirkaŭan realan mondon. Ni ne progresis. Kvazaŭ maŝinoj, ni estis programigitaj por certa agado. Ni scipovis manipuli per maŝinaro, ripari ĝin, eč perfektigi en certa grado – sed ni ne sciis la principojn, sur kiuj ĝi estis bazita, ĝi restis fremda kaj nekomprenebla por ni. Ni stiris, veldis, pudlis kun helpo de «magiaj paroloj»-instrukcioj kaj senkonscie parkerigitaj movoj – pri tio zorgis niaj Rit-instruistoj.
    </p>

    <p class="mb-3">
      Ni perdis la nian kaj ne akiris la alian; ni entute nenion akiris.
    </p>

    <p class="mb-3">
      La instrukcioj al maŝinoj iĝis niaj Sanktaj Libroj; la pastroj klarigis al ni, kiel funkciigi la aparataron; kaj ni, memorfiksante, obeis kaj kredis. Kvazaŭ blindaj, dum jarcentoj ni preĝis anstataŭ kompreni, anstataŭ rigardi kaj vidi.
    </p>

    <p class="mb-5">
      Tuta nia civilizacio,  tiom potenca, atinginta aliujn astrojn, evidentiĝis nur pura blufo…
    </p>


    <p class="mb-3">
      Sed kiuj estis tiuj «Bonfarantoj», kiuj feliĉigis nin? Kiu faris tiun teruran eksperimenton super la homaro – senigis ĝin de la propra vojo?
    </p>

    <p class="mb-3">
      Mi unusola el ĉiuj homoj savis min. Sub influo de ĉi-planedo la Rito foriĝis el mia kapo kaj mi iĝis normala homo – vivanta inter vivantaj, vidanta inter vidantaj.
    </p>

    <p class="mb-3">
      Almenaŭ al tiu ĉi tribo mi povas klarigi ĉion: ili estas tiom naivaj, tiel kredas al mi. Mi rakontos al ili pri nia fiaskita kulturo, pri malutilo de maŝinprogreso, pri la ĉarmo de la natura vivo, - ĉion, kion mi mem eksentis; kaj ili komprenos min, ili ne sekvos nian misan vojon!
    </p>

    <p class="mb-3">
      Ne al Maŝinaro – al Naturo devas strebi homo por disvolviĝi kreske; al Naturo ĉirkaŭa kaj al naturo sia propra. Mi instruos ilin, ke ĉiu popolo, ĉiu homo devas sekvi sian propran vojon de evoluo. Nur libera elekto, sen ies «bonfarado» aŭ sugesto, povas montri la vojon al feliĉo.
    </p>

    <p class="mb-5">
      Mi direktos ilin al Vero, kaj ili estos ĉiopovaj, ili plene, kun apertaj okuloj ekposedos la mondon. Ili evitos niajn erarojn kaj, fortaj kaj liberaj, sendependaj de fremdaj influoj, ili atingos feliĉon! Tio estas la devo de mia konscienco antaŭ ili.
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>


    <p class="mb-3 italic">
      Estu laŭdata, nia bonfaranto! Estu beata Vi kaj la Mesaĝo Via, la sola nia torĉo en mallumo.
    </p>
    <p class="mb-3 italic">
      Nur sekvante Vin, saviĝos ni.
    </p>
    <p class="mb-3 italic">
      Gloron al nia unua Pastro!
    </p>
    <p class="mb-3 italic">
      Ni, Viaj adorantoj, faros ĉion, por ke homoj sekvu Vin, neniam deflankiĝante, nur laŭ la vojo, de Vi trovita, la sola vera.
    </p>
    <p class="mb-3 italic">
        Ni rakontos Viajn vortojn al niaj posteuloj, kaj dum la mondo nia ekzistas, ekzistos la kredo je la Scio, donita de Vi.
    </p>
    <p class="mb-3 italic">
      Ni konservos ĝin zorge, ni instruos ĝin al ĉiuj vivantaj kaj vivontaj.
    </p>
    <p class="mb-3 italic">
      Ni konstruos preĝejojn kaj lernejojn, kaj en multaj generacioj ne perdiĝos eĉ unu vorto, dirita de Vi.
    </p>
    <p class="mb-3 italic">
      Gloron al la Mastro de niaj vivoj!
    </p>
    <p class="mb-3 italic">
      Dum ni vivas, neniu disobeos Vin; kaj ni ĉiuj saviĝos per la vortoj Viaj.
    </p>
    <p class="mb-3 italic">
      Estu beata por ĉiam!
    </p>
    `
  )
}

const itemName = {
  esp: 'La cirklo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;